var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ActionLoader } from '@/components/ui/Button/ActionLoader';
import { Button } from '@/components/ui/Button/Button';
/**
 * submitやローディングを伴うボタンコンポーネント
 * @param props
 * @constructor
 */
export const SubmitButton = (props) => {
    const { children, className = '', disabled, loaderProps, loading = false, type = 'submit', value } = props, buttonProps = __rest(props, ["children", "className", "disabled", "loaderProps", "loading", "type", "value"]);
    return (_jsxs(Button, Object.assign({}, buttonProps, { className: clsx('relative', className), color: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.color) || 'navy', disabled: disabled || loading, size: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.size) || 'md', type: type, value: value }, { children: [loading && (_jsx(ActionLoader, { spinnerColor: loaderProps === null || loaderProps === void 0 ? void 0 : loaderProps.spinnerColor, spinnerSize: loaderProps === null || loaderProps === void 0 ? void 0 : loaderProps.spinnerSize })), children] })));
};
